module.exports = __webpack_public_path__ + "img/olej4.bafb729b.jpg";